import {
  Button,
  Input,
  Form,
  notification,
  PageHeader,
  Col,
  Row,
  InputNumber,
  Radio,
  DatePicker,
} from "antd";
import { useEffect, useState } from "react";
import { Prompt, useHistory } from "react-router-dom";
import "../../Tools/customStyles.css";
import { useAuth } from "../../context/auth";
import MerchantDropdown from "../Dropdown/MerchantDropdown";
import LandlordDropdown from "../Dropdown/LandlordDropdown";
import IconCard from "../../static/icon/IconCard";
import moment from "moment";

const PromotionSetting = ({ match: { params: { type, id } } }) => {
  const history = useHistory();
  const { accessToken, adminRole } = useAuth();

  const [form] = Form.useForm();
  const code = Form.useWatch('code', form);
  const count = Form.useWatch('count', form);
  const internal = Form.useWatch('internal', form);
  const merchantIds = Form.useWatch('merchantIds', form);

  useEffect(() => {
    if (type === 'landlord')
      form.setFieldsValue({ internal: true, expose: false });
    if (type === 'point')
      form.setFieldsValue({ internal: false });
  }, [form, type]);

  useEffect(() => {
    if (!internal)
      form.setFieldsValue({
        merchantIds: [],
        landlordIds: [],
      });
  }, [form, internal]);

  const [change, setChange] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (id === 'new') return;

    async function getPromotion() {
      const url = new URL('/api/promotion/' + id, window.location);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { promotion } = await res.json();

        if (promotion.validFrom) promotion.validFrom = moment(promotion.validFrom);
        if (promotion.validTo) promotion.validTo = moment(promotion.validTo);

        form.setFieldsValue(promotion);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    setChange(false);
    getPromotion();
  }, [accessToken, form, id]);

  const save = async (values) => {
    setDisabled(true);
    setChange(false);

    const url = new URL(id === 'new' ? '/api/promotion' : '/api/promotion/' + id, window.location);

    const res = await fetch(url, {
      method: id === 'new' ? 'POST' : 'PATCH',
      headers: {
        'X-ACCESS-TOKEN': accessToken,
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        ...values,
        type,
      }),
    });
    if (res.ok) {
      if (id === 'new') {
        if (values.count > 1) {
          const { codes } = await res.json();
          const a = document.createElement('a');
          a.download = values.code + '.csv';
          a.href = URL.createObjectURL(new Blob([codes.join('\n')], { type: 'text/csv' }));
          a.click();
        }
      }
      notification["success"]({
        message: "Successfully saved data.",
      });
      history.push({
        pathname: `/promotion/${type}`,
        searchValue: history.location.searchValue,
        pageValue: history.location.pageValue,
      });
    } else if (res.status === 409) {
      notification["warn"]({
        message: "Code is already used",
      });
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setDisabled(false);
    setChange(true);
  };

  const [downloading, setDownloading] = useState(false);
  async function download() {
    setDownloading(true);

    const url = new URL('/api/promotion/' + id + '/code', window.location);

    const res = await fetch(url, {
      headers: { 'X-ACCESS-TOKEN': accessToken },
    });
    if (res.ok) {
      const { codes } = await res.json();
      const a = document.createElement('a');
      a.download = code + '.csv';
      a.href = URL.createObjectURL(new Blob([codes.join('\n')], { type: 'text/csv' }));
      a.click();

      notification["success"]({
        message: "Codes downloading has been started.",
      });
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setDownloading(false);
  }

  return (
    <>
      <div className="flex justify-between items-center mt-2">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconCard /> &nbsp;&nbsp;Promotion Setting
            </span>
          }
        />
      </div>
      <div className="content">
        <div className="search">
          <Form
            form={form}
            onFinish={save}
            onFieldsChange={() => setChange(true)}
            className="search_inline row m-auto w-3/4 py-6"
          >
            <Row gutter={[32, 8]} style={{ marginTop: 15 }}>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Code"
                  name="code"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Code is required.",
                    },
                    {
                      whitespace: true,
                      message: "Code is not whitespace",
                    },
                    {
                      pattern: /^[A-Za-z0-9]+$/,
                      message: "Only A-Z a-z 0-9 is allowed",
                    },
                  ]}
                  className="mt-2"
                >
                  <Input
                    placeholder="Code"
                    maxLength={250}
                    disabled={id !== 'new'}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Example Code"
                  colon={false}
                  className="mt-2"
                >
                  {count === 1 && code}
                  {count > 1 && code + 'RxJ5X'}
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Number of code to be generated"
                  name="count"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Number of code is required.",
                    },
                    {
                      type: 'number',
                      min: 1,
                      max: 1000,
                      message: "Number of code must be between 1-1000",
                    },
                  ]}
                  className="mt-2"
                >
                  <InputNumber
                    placeholder="Number of code to be generated"
                    maxLength={255}
                    className="w-full"
                    disabled={id !== 'new'}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Limit usage per generated code"
                  name="total"
                  colon={false}
                  rules={[
                    {
                      type: 'number',
                      min: 1,
                      message: "Number of code must be at least 1",
                    },
                  ]}
                  className="mt-2"
                >
                  <InputNumber
                    placeholder="Limit usage per generated code"
                    maxLength={255}
                    className="w-full"
                    allowClear
                    disabled={id !== 'new'}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Promotion Name (EN)"
                  name="nameEn"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Promotion Name (EN) is required.",
                    },
                    {
                      whitespace: true,
                      message: "Promotion Name (EN) is not whitespace",
                    },
                  ]}
                  className="mt-2"
                >
                  <Input
                    placeholder="Promotion Name (EN)"
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Promotion Name (TH)"
                  name="nameTh"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Promotion Name (TH) is required.",
                    },
                    {
                      whitespace: true,
                      message: "Promotion Name (TH) is not whitespace",
                    },
                  ]}
                  className="mt-2"
                >
                  <Input
                    placeholder="Promotion Name (TH)"
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Area Type"
                  name="internal"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Area Type is required.",
                    },
                  ]}
                >
                  <Radio.Group
                    options={[
                      { value: true, label: 'Selected Landlord' },
                      { value: false, label: 'Public Used' },
                    ]}
                    disabled={type === 'landlord' || type === 'point' || id !== 'new'}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Homepage"
                  name="expose"
                  colon={false}
                  rules={[
                    {
                      required: type !== 'landlord',
                      message: "Homepage is required.",
                    },
                  ]}
                >
                  <Radio.Group
                    options={[
                      { value: true, label: 'Show in homepage' },
                      { value: false, label: 'Hide from public' },
                    ]}
                    disabled={type === 'landlord'}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Cluster Name"
                  name="merchantIds"
                  colon={false}
                  className="mt-2"
                >
                  <MerchantDropdown
                    allowClear
                    allowSearch
                    mode="multiple"
                    setSelectedMerchants={(merchantIds) => form.setFieldsValue({ merchantIds })}
                    disabled={!internal || id !== 'new'}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Site Name"
                  name="landlordIds"
                  colon={false}
                  rules={[
                    {
                      required: internal,
                      message: "Site Name is required.",
                    },
                  ]}
                  className="mt-2"
                >
                  <LandlordDropdown
                    allowClear
                    allowSearch
                    mode="multiple"
                    merchantIds={merchantIds}
                    setSelectedLandlords={(landlordIds) => form.setFieldsValue({ landlordIds })}
                    disabled={!internal || id !== 'new'}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Valid From"
                  name="validFrom"
                  colon={false}
                  className="mt-2"
                >
                  <DatePicker
                    showTime
                    className="w-full"
                    disabled={id !== 'new'}
                  />
                </Form.Item>
              </Col>
              <Col span={24} lg={12}>
                <Form.Item
                  label="Valid To"
                  name="validTo"
                  colon={false}
                  className="mt-2"
                >
                  <DatePicker
                    showTime
                    className="w-full"
                    disabled={id !== 'new'}
                  />
                </Form.Item>
              </Col>
              {type === 'discount' && (
                <>
                  <Col span={24} lg={12}>
                    <Form.Item
                      label="Discount Percent"
                      name="discountPercent"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Discount Percent is required.",
                        },
                        {
                          type: 'number',
                          min: 0,
                          max: 100,
                          message: "Discount Percent must be between 0-100%",
                        },
                      ]}
                      className="mt-2"
                    >
                      <InputNumber
                        showTime
                        className="w-full"
                        addonAfter="%"
                        disabled={id !== 'new'}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24} lg={12}>
                    <Form.Item
                      label="Discount Baht"
                      name="discountBaht"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Discount Baht is required.",
                        },
                        {
                          type: 'number',
                          min: 0,
                          message: "Discount Baht must be at least 0 Baht",
                        },
                      ]}
                      className="mt-2"
                    >
                      <InputNumber
                        showTime
                        className="w-full"
                        addonAfter="Baht"
                        disabled={id !== 'new'}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
              {type === 'point' && (
                <>
                  <Col span={24} lg={12}>
                    <Form.Item
                      label="Point"
                      name="point"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Point is required.",
                        },
                        {
                          type: 'number',
                          min: 0,
                          message: "Point must be at least 0",
                        },
                      ]}
                      className="mt-2"
                    >
                      <InputNumber
                        showTime
                        className="w-full"
                        addonAfter="Green point"
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>

            <div className="m-auto pt-6 flex justify-center space-x-4">
              <Button
                className="w-36"
                type="primary"
                ghost
                shape="round"
                htmlType="button"
                onClick={() => {
                  history.push({
                    pathname: `/promotion/${type}`,
                    searchValue: history.location.searchValue,
                    pageValue: history.location.pageValue,
                  });
                }}
              >
                Cancel
              </Button>
              <Button
                className="w-36"
                key="save"
                type="primary"
                shape="round"
                htmlType="submit"
                disabled={disabled}
              >
                {count > 1 && id === 'new' ? 'Save and download' : 'Save'}
              </Button>
              {['admin'].includes(adminRole) && id !== 'new' && count > 1 && (
                <Button
                  className="w-36"
                  key="save"
                  type="primary"
                  shape="round"
                  loading={downloading}
                  onClick={download}
                >
                  Download
                </Button>
              )}
            </div>
          </Form>
        </div>
      </div>
      <Prompt when={change} message="Changes will not be saved. Do you want to proceed ?" />
    </>
  );
};
export default PromotionSetting;
